import { useEffect, useState } from "react";
import { BellRing, CalendarCheck, FileText, MailCheck } from "lucide-react";

import { useAuth } from "@/context/AuthContext";
import { request } from "@/lib/api";

const iconFor = (type) => type.includes("report") ? FileText : type.includes("appointment") ? CalendarCheck : MailCheck;

const updateTitle = (type) => ({
  appointment_confirmation: "Appointment confirmation",
  appointment_letter: "Appointment letter prepared",
  employee_reminder: "Appointment reminder",
  center_reminder: "Medical centre reminder",
  reschedule_request_received: "Reschedule request sent",
  cancel_request_received: "Cancellation request sent",
  awaiting_payment_reminder: "Payment needed to book",
  consultation_confirmation: "Consultation request received",
  booking_cancelled_by_provider: "Appointment cancelled",
  appointment_visited: "Visit confirmed",
  appointment_not_visited: "Missed appointment",
  booking_rescheduled_by_provider: "Appointment rescheduled",
  report_ready: "Reports ready",
  report_partial: "Reports partially ready",
  reschedule_confirmed: "Reschedule confirmed",
  cancellation_confirmed: "Cancellation confirmed",
  change_request_rejected: "Request couldn't be processed",
}[type] || type.replaceAll("_", " "));

const displayTime = (value) => new Intl.DateTimeFormat("en-IN", { day: "numeric", month: "short", hour: "numeric", minute: "2-digit" }).format(new Date(value));

export default function UpdatesPage() {
  const { token } = useAuth();
  const [updates, setUpdates] = useState([]);

  useEffect(() => {
    request("/communications", {}, token).then(setUpdates).catch(() => setUpdates([]));
  }, [token]);

  return <section className="page-stack" data-testid="updates-page"><div className="page-heading"><p className="eyebrow">Care updates</p><h1>Stay on top of every care moment.</h1><p>Booking confirmations, appointment reminders, change requests, and report updates appear here.</p></div><section className="updates-list" data-testid="communications-list">{updates.length ? updates.map((update) => { const Icon = iconFor(update.type); return <article className="update-item" key={update.notification_id} data-testid={`communication-${update.notification_id}`}><Icon size={20} /><div><strong>{updateTitle(update.type)}</strong><span>{update.booking_id} · {displayTime(update.created_at)}</span></div><small>{update.status}</small></article>; }) : <div className="empty-updates" data-testid="empty-communications"><BellRing size={28} /><p>Your care updates will appear here.</p></div>}</section></section>;
}